<template>
  <div id="LoginBox">
    <div class="login_logo">
      <a href="/" class="logo"></a>
      <h1>{{$t('base.signUpTo')}}</h1>
    </div>
    <el-form class="register_box" :model="ruleForm" :rules="rules" ref="ruleForm">
      <!-- 国籍和手机号 -->
      <el-form-item class="login_form_item" prop="TelPhone">
        <!-- 国籍 -->
        <div class="locationPhoneBox">
          <div class="countries" v-if="ruleForm.MemberSource!=''">
            <img :src="ruleForm.LocationIcon" alt="">
          </div>
          <el-select class="login_ipt" :class="ruleForm.MemberSource!=''?'nolocation':''" placeholder="" v-model="ruleForm.MemberSource" popper-class='location' @change='changeLocation'>
            <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
              <div class="locationOption">
                <img :src="item.IconUrl">
                <span>{{item.EnName}}</span>
              </div>
            </el-option>
          </el-select>
            <div class="nationCode">
              {{ruleForm.MemberSource}}
            </div>
        </div>
        <!-- 手机号 -->
        <el-input class="login_ipt email" v-model="ruleForm.LocationName" disabled :placeholder="$t('colon.country')"></el-input>
      </el-form-item>
      <!-- 用户名 -->
      <el-form-item class="login_form_item" prop="nickName">
        <el-input class="login_ipt" v-model="ruleForm.nickName" minlength='6' :placeholder="$t('rules.usernameWarning')" @input="forbidInput('nickName')">
        </el-input>
      </el-form-item>
      <!-- 邮箱 -->
      <el-form-item class="login_form_item" prop="email">
        <el-input class="login_ipt" v-model="ruleForm.email" disabled :placeholder="$t('base.email')">
        </el-input>
      </el-form-item>
      <!-- 密码 -->
      <el-form-item class="login_form_item" prop="password">
        <el-input class="login_ipt" :type="flagType" v-model="ruleForm.password" minlength='6' maxlength='20' :placeholder="$t('base.enterPassword')" :readonly='readonly' @focus='focusReadonly' @input="forbidInput('password')">
          <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
        </el-input>
      </el-form-item>
      <!-- 提交按钮 -->
      <div class="forgot">{{$t('rules.pwdTip')}}</div>
      <el-input class="login_ipt" v-model="ruleForm.InviteCode" :placeholder="$t('base.PromoCode')">
      </el-input>
      <el-button class="text_btn" type="primary" :disabled="disabled" @click="submitForm('ruleForm')">{{$t('base.signUp')}}</el-button>
      <!-- 合规文档 -->
      <div class="terms_checked">
        <el-checkbox v-model="checkbox" :label="1">{{radioNumber}}</el-checkbox>
        <div>
          {{$t('base.agreeTo')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}
          </router-link> {{$t('base.and')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}
          </router-link>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { CensoredEmail, getUser, isEmoji } from "@/api/public";
export default {
  name: '',
  data() {
    var numSix = (rule, value, callback) => {
      if (value.length > 0 && value.length < 6) {
        var name = 'Password'
        if (rule.field == 'nickName') { name = 'NickName' }
        callback(new Error(name + this.$t('rules.pwdCharacter')));
      } else {
        callback();
      }
    };
    var isChinese = (rule, value, callback) => {
      let reg = /[\u4E00-\u9FA5]/g;
      let ChineseLength = (value.match(reg) || []).length
      if (ChineseLength > 0) {
        var msg = this.$t('rules.isChinese')
        callback(new Error(msg));
      }
      callback();
    }
    return {
      readonly: true,
      smsMsg: '',
      disabled: false, // 按钮禁用
      // checked: false,
      radioNumber: '', // 是否勾选查看合规条款
      checkbox: false, // 是否选中条款
      times: 120, // 默认倒计时120秒
      isCode: true, // 判断是否已在倒计时
      flagType: 'password', //密码切换状态
      flag: false, //密码切换状态
      ifshow: false, //是否显示查看密码的图标
      isUserData:null,
      ruleForm: {
        nickName: '',
        email: '',
        password: '',
        LocationIcon: '',
        LocationName: '',
        MemberSource: '',
        AreaCode: '',
        InviteCode: '',
        GoogleUserId:''
      },rules: {
        nickName: [
           { required: true, message: this.$t('rules.nicknameRule'), trigger: 'blur' },
           { validator: numSix, trigger: 'blur' },
          { pattern: /^[^[\u4E00-\u9FA5]+$/, message: 'The nickname does not support Chinese characters.', trigger: 'blur' },
        ],
        email:[
          { required: true, message: this.$t('rules.invalidEmailAgain'), trigger: 'blur' },
          { type: 'email', message: this.$t('rules.invalidEmailAgain'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('rules.pwdCharacterRule'), trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('rules.pwdRule'), trigger: 'blur' },
        ]
      }
    }
  },
  props: {
    gdata: {},
    locationOption: {}
  },

  watch: {
    'locationOption': {
      handler(obj) {
        //console.log(obj,'locationOption')
        this.getNationIcons()
      }
    }
  },
  created() {},
  mounted() {
    let that = this
    this.getNationIcons()
    window.addEventListener('keydown', function(e) {
      if (e.keyCode === 13) {
        that.submitForm('ruleForm')
      }
    })
  },
  methods: {
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.ruleForm.MemberSource = res.Code
          that.ruleForm.LocationIcon = res.IconUrl
          that.ruleForm.LocationName = res.EnName
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      //console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      try {
        const locationOne = that.locationOption[0]
        that.ruleForm.MemberSource = locationOne.Code //
        that.ruleForm.LocationIcon = locationOne.IconUrl
        that.ruleForm.LocationName = locationOne.EnName
        that.ruleForm.AreaCode = locationOne.NationCode
        that.ruleForm.email=that.gdata.email
        that.ruleForm.nickName=that.gdata.name
        that.ruleForm.GoogleUserId=that.gdata.sub
      } catch (error) {}
    },
    focusReadonly() {
      this.readonly = false
    },
    forbidInput(e) {
      let num = 1
      if (e === 'password') {
        num = 1
      } else if (e === 'nickName') {
        this.ruleForm.nickName = isEmoji(this.ruleForm[e], num)
        this.ruleForm.nickName = this.ruleForm.name.substring(0, 20);
      }
      this.ruleForm[e] = isEmoji(this.ruleForm[e], num)
      //是否显示查看密码的图标
      this.ifshow = false
      if (this.ruleForm.password) {
        this.ifshow = true
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      // console.log(this.flag,this.flagType)
    },
    // 登入
    submitForm(formName) {
      let that = this;
      that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkbox == false) {
            this.$confirm(`<div style="padding: 0 24px;">` + that.$t('alert.toProceed') + ` <a href="#/terms/privacy?type=2"  target="_blank" class="text_blue">` + that.$t('base.service') + `</a> ` + that.$t('base.and') + ` <a href="#/terms/privacy?type=1"  target="_blank" class="text_blue">` + that.$t('base.privacy') + `</a>.</div>`, that.$t('base.notice'), {
                // showConfirmButton: true ,
                customClass: "NoticeBox",
                dangerouslyUseHTMLString: true,
                confirmButtonText: that.$t('base.agree'),
                cancelButtonText: that.$t('base.cancel'),
              }).then(() => {
                that.checkbox = true;
                that.submitForm('ruleForm');
              })
              .catch(() => {

              });
          } else {
            that.$post(that.$interface.RegisterGoogleUserId,that.ruleForm).then(res=>{
              if (res.Result != 0) {
                this.$message({
                  type: 'success',
                  duration: 1000,
                  message: 'Registered successfully!'
                });
                getUser(res.Data)
              } else {
                that.$message({
                  type: 'error',
                  duration: 1000,
                  message: res.Msg
                });
              }
              that.disabled = false;
            })
            that.disabled = true;
            that.loading = true;
            //
          }
        }
      })
    },
    removeListener() {
      // 删除监听
      window.removeEventListener('keydown', function(e) {});

    }
  },
  beforeDestroy() {
    this.removeListener()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/login.css";

/deep/ .el-icon-arrow-up:before {
  /* margin: 0 0 0 15px; */
  color: #a0a0a0;
  font-weight: normal;
}

.el-button {
  margin: 30px 0 0;
}

.locationOption {
  display: flex;
  align-items: center;
}

.locationOption img {
  width: 24px;
  height: 17px;
  margin-right: 10px;
}

/deep/ .locationelOption.hover,
.locationelOption:hover,
.locationelOption.selected {
  background-color: #f8f8f8;
}
/deep/ .el-input.is-disabled .el-input__inner{
  border: none;
}

.register_box .forgot {
  padding-bottom: 20px;
  padding-top: 2px;
}

.terms_checked {
  margin-bottom: 5px;
}

.terms {
  color: #a0a0a0;
  margin-bottom: 12px;
  line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// src/components/googleregister.vue